import React from 'react';
import { Button, message } from 'antd';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { LogoutOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons';

const DepartmentLayout = () => {
  const navigate = useNavigate();
  const { companySlug } = useParams();

  const handleLogout = () => {
    localStorage.removeItem('department_token');
    localStorage.removeItem('department_admin');
    message.success('已退出登录');
    navigate(`/${companySlug}/department/login`);
  };

  const deptAdmin = JSON.parse(localStorage.getItem('department_admin') || '{}');

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {/* 顶栏 */}
      <div style={{
        background: '#fff',
        padding: '0 16px',
        height: 52,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <AppstoreOutlined style={{ fontSize: 18, color: '#8B7355' }} />
          <span style={{ fontSize: 16, fontWeight: 600, color: '#8B7355' }}>
            {deptAdmin.department_name || '部门后台'}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ color: '#666', fontSize: 13 }}>
            {deptAdmin.real_name || deptAdmin.username}
          </span>
          <Button
            type="text"
            size="small"
            icon={<SettingOutlined />}
            onClick={() => navigate(`/${companySlug}/department/presets`)}
            style={{ fontSize: 13 }}
          >
            预设
          </Button>
          <Button
            type="text"
            size="small"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          />
        </div>
      </div>

      {/* 内容区 */}
      <div style={{ padding: '12px', maxWidth: 800, margin: '0 auto' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default DepartmentLayout;
